module.exports = __webpack_public_path__ + "static/media/coffee.7f4c48b5.svg";